/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/ForecastModel', 'model/ForecastModelReport'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/ForecastModel'), require('../model/ForecastModelReport'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.ForecastModelApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.ForecastModel, root.ForStractionServiceApi.ForecastModelReport);
  }
}(this, function(ApiClient, ForecastModel, ForecastModelReport) {
  'use strict';

  /**
   * ForecastModel service.
   * @module api/ForecastModelApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new ForecastModelApi. 
   * @alias module:api/ForecastModelApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the forecastModelAddPut operation.
     * @callback module:api/ForecastModelApi~forecastModelAddPutCallback
     * @param {String} error Error message, if any.
     * @param {'Integer'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * add
     * @param {String} _4SAPIAppID 
     * @param {module:model/ForecastModel} body 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.childrenTrackingLevelID 
     * @param {module:api/ForecastModelApi~forecastModelAddPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'Integer'}
     */
    this.forecastModelAddPut = function(_4SAPIAppID, body, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling forecastModelAddPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling forecastModelAddPut";
      }


      var pathParams = {
      };
      var queryParams = {
        'childrenTrackingLevelID': opts['childrenTrackingLevelID']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Integer';

      return this.apiClient.callApi(
        '/ForecastModel/add', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the forecastModelAggregateDataGet operation.
     * @callback module:api/ForecastModelApi~forecastModelAggregateDataGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * aggregateData
     * @param {String} _4SAPIAppID 
     * @param {Integer} modelID 
     * @param {Object} opts Optional parameters
     * @param {Boolean} opts.preview  (default to false)
     * @param {module:api/ForecastModelApi~forecastModelAggregateDataGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.forecastModelAggregateDataGet = function(_4SAPIAppID, modelID, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling forecastModelAggregateDataGet";
      }

      // verify the required parameter 'modelID' is set
      if (modelID == undefined || modelID == null) {
        throw "Missing the required parameter 'modelID' when calling forecastModelAggregateDataGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'modelID': modelID,
        'preview': opts['preview']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/ForecastModel/aggregateData', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the forecastModelDeleteGet operation.
     * @callback module:api/ForecastModelApi~forecastModelDeleteGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * delete
     * @param {String} _4SAPIAppID 
     * @param {Integer} modelID 
     * @param {module:api/ForecastModelApi~forecastModelDeleteGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.forecastModelDeleteGet = function(_4SAPIAppID, modelID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling forecastModelDeleteGet";
      }

      // verify the required parameter 'modelID' is set
      if (modelID == undefined || modelID == null) {
        throw "Missing the required parameter 'modelID' when calling forecastModelDeleteGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'modelID': modelID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/ForecastModel/delete', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the forecastModelEditPut operation.
     * @callback module:api/ForecastModelApi~forecastModelEditPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * edit
     * @param {String} _4SAPIAppID 
     * @param {module:model/ForecastModel} body 
     * @param {module:api/ForecastModelApi~forecastModelEditPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.forecastModelEditPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling forecastModelEditPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling forecastModelEditPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/ForecastModel/edit', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the forecastModelLoadAllGet operation.
     * @callback module:api/ForecastModelApi~forecastModelLoadAllGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/ForecastModelReport>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * loadAll
     * @param {String} _4SAPIAppID 
     * @param {module:api/ForecastModelApi~forecastModelLoadAllGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/ForecastModelReport>}
     */
    this.forecastModelLoadAllGet = function(_4SAPIAppID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling forecastModelLoadAllGet";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [ForecastModelReport];

      return this.apiClient.callApi(
        '/ForecastModel/loadAll', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the forecastModelLoadGet operation.
     * @callback module:api/ForecastModelApi~forecastModelLoadGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ForecastModelReport} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * load
     * @param {String} _4SAPIAppID 
     * @param {Integer} modelID 
     * @param {module:api/ForecastModelApi~forecastModelLoadGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ForecastModelReport}
     */
    this.forecastModelLoadGet = function(_4SAPIAppID, modelID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling forecastModelLoadGet";
      }

      // verify the required parameter 'modelID' is set
      if (modelID == undefined || modelID == null) {
        throw "Missing the required parameter 'modelID' when calling forecastModelLoadGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'modelID': modelID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = ForecastModelReport;

      return this.apiClient.callApi(
        '/ForecastModel/load', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
